<template src="./handler.html"></template>

<script>
import VueResizable from 'vue-resizable';
import goodsTopMenu from "@/components/goods/components/topMenu";
import Pagination from "@/components/components/pagination";
import RangeFilter from "@/components/components/RangeFilter";
import {createNamespacedHelpers} from 'vuex';
import {config} from "@/config";
import productLang from "../../../constants/goods";

const {mapGetters, mapActions} = createNamespacedHelpers('goods/handler')
// not editable field
const NOT_EDITABLE_FIELD = [
  'updated_date',
  'lastOrderDate',
  'seoFlag',
  'comment_1',
  'comment_2',
  'comment_3',
  'comment_4',
  'comment_5',
  'comment_6',
  'comment_7',
  'comment_8',
  'comment_9',
  'comment_10',
]

export default {
  name: "Handler",
  components: {
    VueResizable,
    goodsTopMenu,
    Pagination,
    RangeFilter
  },
  data() {
    return {
      productLang,
      cellDetailList: [],
      cellDetailLink: '',
      cellDetailLinkList: [],
      windowHeight: false,
      mainTableTop: false,
      mainErrorTableTop: false,
      hostApi: config.apiUrl,
      tabScrollStyle: {
        width: '1725px',
        height: '400px',
        float: 'none'
      },
      tabWidthStyle: {
        width: '1000px',
      },
      resizeWidth: '1700px',
      idSign: false,
      idToSign: false,
      filterData: {},
      idFilter: null,
      idToFilter: null,
      showOverlay: false,

      totalCheckBox: false,
      selectedRow: {},
      deleteNumber: 0,
      isEdit: false,
      isListEdit: false,

      currentProductId: null,
      currentField: null,
      isShowCell: false,
      isListShowCell: false,
      cellDetailLinkEdit: '',
      cellDetailTextEdit: '',

      actionOptions: [
        {value: '', text: 'Виберите дейст.'},
        {value: 'newValue', text: 'Новое значение'},
        {value: 'toEmpty', text: 'Удалить значения'},
        {value: 'replace', text: 'Заменить'},
        {value: 'cellSwap', text: 'Поменять местами'},
        {value: 'setColumnToColumn', text: 'Значние из колонки'},
      ],
      actionValue: {},
      isFiltered: false,
      resetRangeFilterFunction: null,

      globalEdit: null,

      globalNewValue: null,
      globalNewValueIfEmpty: true,
      global: null,
      globalCurrentField: null,
      globalSearch: null,
      globalReplace: null,
      globalColumnSwap2: null,
      globalSourceColumn: null,

      selectedField: {},
      changed: null,
    }
  },
  methods: {
    ...mapActions([
      'GET_ALL',
      'DELETE',
      'SAVE',
      'SELECTED_SAVE',
    ]),
    applySelectedField() {
      this.SELECTED_SAVE({th: this, fields: this.getSelectedFile})
      this.$nextTick(() => {
        this.$root.$emit('bv::toggle::collapse', 'collapse-1')
      })

    },
    allSelectedField() {
      for (let key in this.selectedField) {
        this.$set(this.selectedField, key, true)
      }
    },
    resetSelectedField() {
      for (let key in this.selectedField) {
        this.$set(this.selectedField, key, false)
      }
    },
    goToEdit(id) {
      window.open(this.getEditUrl(id), '_blank').focus()
    },
    getEditUrl(id) {
      return this.$router.resolve({
        name: 'goodEdit',
        params: {id: id},
      }).href
    },
    changeSing: function (sing, val, rangeFilterData) {
      if (val == '' || val == null || val == undefined) {
        return;
      }

      this.setFilter(rangeFilterData);
    },
    changeRangeVal: function (sing, val, rangeFilterData, resetFilter) {
      this.resetRangeFilterFunction = resetFilter
      if (sing == undefined) {
        return;
      }

      this.setFilter(rangeFilterData);
    },
    markCell: function (event) {
      // toggle focus of cell
      const textEl = this.$refs.mainTable.$el;
      const selectedEl = textEl.querySelector('.selectedCall');
      if (selectedEl != null) {
        selectedEl.classList.remove('selectedCall');
      }
      event.target.classList.add('selectedCall');
      this.$nextTick(() => {
        this.windowResize();
      });
    },
    markRow: function () {
      const textEl = this.$refs.mainTable.$el;
      // clean
      const selectedRow = textEl.querySelectorAll('.isSelectedRow')
      selectedRow.forEach((el) => {
        el.classList.remove('isSelectedRow')
      })
      const selectedEl = textEl.querySelectorAll('.isSelected')
      selectedEl.forEach((el) => {
        el.parentElement.parentElement.classList.add('isSelectedRow')
      })
    },
    markCellSpan: function (ref) {
      // toggle focus of cell
      const textEl = this.$refs.mainTable.$el;
      const selectedEl = textEl.querySelector('.selectedCall');
      if (selectedEl != null) {
        selectedEl.classList.remove('selectedCall');
      }
      this.$refs[ref].classList.add('selectedCall');
      this.$nextTick(() => {
        this.windowResize();
      });
    },
    showCellContent: function (text, productId, field, translationBacklight) {
      // switch of edit
      this.isEdit = false
      this.isListEdit = false
      // remember of product id and field
      this.currentProductId = productId
      this.currentField = field
      // show detail
      this.cellDetailLink = ''
      this.cellDetailList = []
      this.cellDetailLinkList = []
      if (text.indexOf('http') !== -1) {
        this.cellDetailLink = text
      } else {
        this.cellDetailList = translationBacklight
      }
      this.$nextTick(() => {
        this.windowResize()
      })
      this.isShowCell = true
      this.cellDetailTextEdit = text
    },
    showPhotoPdf: function (value, productId, field) {
      // check if is information message
      if (value == 'processing') {
        this.cellDetailLink = ''
        this.cellDetailList = []
        this.cellDetailLinkList = []
        this.isShowCell = false
        this.isListShowCell = false
        return
      }
      // switch of edit
      this.isEdit = false
      this.isListEdit = false
      // remember of product id and field
      this.currentProductId = productId
      this.currentField = field
      // show detail
      this.cellDetailLink = ''
      this.cellDetailList = []
      this.cellDetailLinkList = value
      this.isListShowCell = true
      this.cellDetailLinkEdit = value.join(' | ')
    },
    goToPage: function (page) {
      this.$store.commit('goods/handler/CURRENT_PAGE', page)
      this.GET_ALL({th: this})
    },
    perPage: function (page) {
      this.$store.commit('goods/handler/PAGE_SIZE', page)
      this.GET_ALL({th: this})
    },
    widthTab: function () {
      this.tabScrollStyle.width = (window.innerWidth - 210) + 'px'
      this.resizeWidth = (window.innerWidth - 230) + 'px'
    },
    getCommentTitle: function (data) {
      if (data.field.key.indexOf('additional_') != -1) {
        let number = data.field.key.replace('additional_', '')
        return data.item['comment_' + number] != null ? data.item['comment_' + number] : ''
      }

      return ''
    },
    setFilter: function (rangeFilterData) {
      this.$store.commit('goods/handler/CURRENT_PAGE', 1)
      this.$store.commit('goods/handler/FILTER_DATA', this.filterData)
      if (rangeFilterData !== undefined) {
        this.$store.commit('goods/handler/RANGE_FILTER_DATA', rangeFilterData)
      }
      this.GET_ALL({th: this})
      this.isFiltered = this.rangeFilterIsSelect() || this.simpleFilterIsSelect()
    },
    initPageSize: function () {
      let winHeight = window.innerHeight
      winHeight = Math.round((winHeight - 520) / 31)
      this.$store.commit('goods/handler/PAGE_SIZE', winHeight)
    },
    sortingChanged: function (ctx) {
      this.$store.commit('goods/handler/CURRENT_SORT_DIR', ctx.sortDesc ? 'desc' : 'asc')
      this.$store.commit('goods/handler/CURRENT_SORT', ctx.sortBy)
      this.GET_ALL({th: this})
    },
    windowResize: function () {
      this.windowHeight = window.innerHeight
      this.$nextTick(() => {
        this.setMainTableTop()
        this.tabScrollStyle.height = (this.windowHeight - this.mainTableTop - 10) + 'px'
      })
    },
    setMainTableTop: function () {
      let rect = this.$refs.mainTable.$el.getBoundingClientRect()
      this.mainTableTop = rect.top
    },
    recountSize: function () {
      this.setMainTableTop()
      this.windowResize()
    },
    totalCheckBoxChange: async function () {
      await this.$nextTick()
      if (this.totalCheckBox) {
        for (let key in this.GOODS_LIST) {
          this.$set(this.selectedRow, this.GOODS_LIST[key].id, this.totalCheckBox)
        }
      } else {
        for (let key in this.selectedRow) {
          this.$set(this.selectedRow, key, this.totalCheckBox)
        }
      }
      this.$nextTick(() => {
        this.markRow()
      })
    },
    checkBoxChange: async function () {
      await this.$nextTick()
      this.markRow()
    },
    goodsDelete: function () {
      let haveSelectFlag = false
      this.deleteNumber = 0
      for (let key in this.selectedRow) {
        if (this.selectedRow[key]) {
          haveSelectFlag = true
          this.deleteNumber++
        }
      }
      if (haveSelectFlag || this.haveFilter) {
        this.$bvModal.show('confirmationDeletion')
      }
    },
    confirmationGoodsDelete: function (force = false) {
      this.DELETE({
        th: this,
        ids: this.getSelectedRow,
        exceptionIds: this.getNoSelectedRow,
        isAllSelected: this.totalCheckBox,
        force: force,
      })
    },
    editCell: function () {
      this.isEdit = false
      this.isListEdit = false

      if (NOT_EDITABLE_FIELD.indexOf(this.currentField) === -1) {
        let textarea = null
        if (this.isListShowCell) {
          this.isListEdit = true
          this.cellDetailLinkEdit = this.cellDetailLinkList.join(' | ')
          textarea = this.$refs.listEditTextarea
        } else {
          this.isEdit = true
          textarea = this.$refs.editTextarea
        }
        // add focus
        this.$nextTick(() => {
          textarea = this.isListShowCell ? this.$refs.listEditTextarea : this.$refs.editTextarea
          textarea = textarea.$el
          if (textarea != undefined) {
            textarea.focus()
          }
        })
      }
    },
    editFocusout: function () {
      // switch edit mode
      this.isEdit = false
      this.isListEdit = false
      this.cleanDetail()
    },
    cleanDetail: function () {
      this.cellDetailList = null
      this.cellDetailLink = null
      this.cellDetailLinkList = null
    },
    editChange: function () {
      // committing changes
      let currentValue = Object.assign({}, this.SINGLE_CHANGE_LIST)
      if (currentValue[this.currentProductId] === undefined) {
        currentValue[this.currentProductId] = {}
      }
      currentValue[this.currentProductId][this.currentField] = this.isListEdit ? this.cellDetailLinkEdit : this.cellDetailTextEdit
      this.$store.commit('goods/handler/SINGLE_CHANGE_LIST', currentValue)
      // set change to table cell
      let oldValue = ''
      for (let key in this.GOODS_LIST) {
        if (this.GOODS_LIST[key].id == this.currentProductId) {
          let buf = [...this.GOODS_LIST]
          oldValue = buf[key][this.currentField]
          // check type of data
          buf[key][this.currentField] = this.isListEdit ? this.cellDetailLinkEdit.split('|') : this.cellDetailTextEdit
          this.$store.commit('goods/handler/GOODS_LIST', buf)
          break
        }
      }
      //  committing changes to log
      // check and prepare
      if (this.isListEdit) {
        oldValue = oldValue.join(' | ')
      }
      let newValue = this.isListEdit ? this.cellDetailLinkEdit : this.cellDetailTextEdit
      let logText = 'Одиночное изменение: продукт {' + this.currentProductId + '} - поле {' + this.getFieldName(this.currentField) + '} - значение {' + oldValue + '} => {' + newValue + '}'
      this.addMessageToChangeLog(logText)
      // switch edit mode
      this.isEdit = false
      this.isListEdit = false
      // switch show cell
      this.isShowCell = false
      this.isListShowCell = false
    },
    getFieldName: function (fieldKey) {
      for (let key in this.FIELDS_LIST) {
        if (this.FIELDS_LIST[key].key == fieldKey) {
          return this.FIELDS_LIST[key].label
        }
      }
    },
    applyChange: function () {
      this.SAVE({
        th: this,
        exceptionIds: this.getNoSelectedRow,
        isAllSelected: this.totalCheckBox,
      })
      this.cleanDetail()
    },
    initValue: function () {
      // inition action value and selectedField
      for (let key in this.FIELDS_LIST) {
        this.actionValue[this.FIELDS_LIST[key].key] = ''
      }
      // inition selectedRow value
      for (let key in this.GOODS_LIST) {
        if (this.selectedRow[this.GOODS_LIST[key].id] === undefined) {
          this.$set(this.selectedRow, this.GOODS_LIST[key].id, this.totalCheckBox)
        }
      }
      // set style
      let width  = this.FIELDS_LIST.length * 125
      this.tabWidthStyle.width = (width < 1725 ? 1725 : width)  +'px'
      // init selectedField
      for (let key in this.FIELDS_LIST_FULL) {
        this.$set(this.selectedField, this.FIELDS_LIST_FULL[key].key, false)
        // to true if is selected
        for (let key2 in this.FIELDS_LIST) {
          if (this.FIELDS_LIST[key2].key == this.FIELDS_LIST_FULL[key].key) {
            this.$set(this.selectedField, this.FIELDS_LIST_FULL[key].key, true)
            break
          }
        }
      }
    },
    filterReset: function () {
      if (this.resetRangeFilterFunction != null) {
        let skeleton = this.resetRangeFilterFunction()
        this.$store.commit('goods/handler/RANGE_FILTER_DATA', skeleton)
      }
      this.filterData = {}
      this.$store.commit('goods/handler/CURRENT_PAGE', 1)
      this.$store.commit('goods/handler/FILTER_DATA', {})
      this.GET_ALL({th: this})
      this.isFiltered = false
    },
    simpleFilterIsSelect: function () {
      for (let key in this.filterData) {
        if (this.filterData[key] != "") {
          return true
        }
      }

      return false
    },
    rangeFilterIsSelect: function () {
      if (this.RANGE_FILTER_DATA !== undefined) {
        for (let key in this.RANGE_FILTER_DATA.fromVal) {
          if (this.RANGE_FILTER_DATA.fromVal[key] != "" && this.RANGE_FILTER_DATA.fromSign[key] !== undefined) {
            return true
          }
        }

        for (let key in this.RANGE_FILTER_DATA.toVal) {
          if (this.RANGE_FILTER_DATA.toVal[key] != "" && this.RANGE_FILTER_DATA.toSign[key] !== undefined) {
            return true
          }
        }
      }

      return false
    },
    actionSelect: function (fieldName) {
      this.globalEdit = this.actionValue[fieldName]
      this.globalCurrentField = fieldName
      // clear of other
      for (let key in this.actionValue) {
        if (key !== fieldName) {
          this.actionValue[key] = ''
        }
      }
    },
    addMessageToChangeLog: function (message) {
      let bufLog = [...this.CHANGE_LOG]
      bufLog.push(message)
      this.$store.commit('goods/handler/CHANGE_LOG', bufLog)
    },
    getActionName: function (value) {
      for (let key in this.actionOptions) {
        if (this.actionOptions[key].value == value) {
          return this.actionOptions[key].text
        }
      }
    },
    addTaskToStorageObject: function (storageObjectName, key, value) {
      let objectBuf = Object.assign({}, this.$store.getters[storageObjectName])
      if (objectBuf[key] === undefined) {
        objectBuf[key] = []
      }
      objectBuf[key].push(value)
      this.$store.commit(storageObjectName, objectBuf)
    },
    saveGlobalAction: function (actionType) {
      let logMessage = 'Глобальное изменение:  ' + this.getActionName(actionType) +' ';
      let actionValue = {}
      switch (actionType) {

        case 'newValue':
          actionValue = {
            globalNewValue: this.globalNewValue,
            globalNewValueIfEmpty: this.globalNewValueIfEmpty,
            field: this.globalCurrentField,
          }
          logMessage += '- поле {'+ this.getFieldName(this.globalCurrentField) +'} - новое значение {'+ this.globalNewValue +'} - только пустые {'+ (this.globalNewValueIfEmpty ? 'да': 'нет') +'}'
          // to default
          this.globalNewValue = null
          this.globalNewValueIfEmpty = true
          break

        case 'toEmpty':
          actionValue = {
            field: this.globalCurrentField,
          }
          logMessage += '- поле {'+ this.getFieldName(this.globalCurrentField) +'}'
          break

        case 'replace':
          actionValue = {
            field: this.globalCurrentField,
            globalSearch: this.globalSearch,
            globalReplace: this.globalReplace,
          }
          logMessage += '- поле {'+ this.getFieldName(this.globalCurrentField) +'} - искомое значение {'+ this.globalSearch +'} - значение замены {'+ this.globalReplace +'}'
          this.globalSearch = null
          this.globalReplace = null
          break

        case 'cellSwap':
          actionValue = {
            field: this.globalCurrentField,
            globalColumnSwap2: this.globalColumnSwap2,
          }
          logMessage += '- Колонка 1 {'+ this.getFieldName(this.globalCurrentField) +'} - Колонка 2 {'+ this.getFieldName(this.globalColumnSwap2) +'}'
          this.globalColumnSwap2 = null
          break

        case 'setColumnToColumn':
          actionValue = {
            field: this.globalCurrentField,
            globalSourceColumn: this.globalSourceColumn,
          }
          logMessage += '- Колонка назначения {'+ this.getFieldName(this.globalCurrentField) +'} - Колонка источник {'+ this.getFieldName(this.globalSourceColumn) +'}'
          this.globalSourceColumn = null
          break
      }

      this.addTaskToStorageObject('goods/handler/GLOBAL_CHANGE_LIST', actionType, actionValue)
      this.addMessageToChangeLog(logMessage)
      this.globalCurrentField = null
      this.globalEdit = null
    },
    resetChange: function (isUpdate = false) {
      if (!isUpdate && Object.keys(this.SINGLE_CHANGE_LIST).length !== 0) {
        this.GET_ALL({th: this})
      }
      this.isShowCell = false
      this.isListShowCell = false
      this.$store.commit('goods/handler/CHANGE_LOG', [])
      this.$store.commit('goods/handler/SINGLE_CHANGE_LIST', {})
      this.$store.commit('goods/handler/GLOBAL_CHANGE_LIST', {})
    },
    copyToClipboard: function (str) {
      if (typeof str === 'object' && str !== null) {
        str = str.join(' | ')
      }
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    },
  },
  computed: {
    ...mapGetters([
      'GOODS_LIST',
      'CURRENT_PAGE',
      'AMOUNT_PAGE',
      'COUNT_ROW',
      'FIELDS_LIST',
      'FIELDS_LIST_FULL',
      'PAGE_SIZE',
      'SINGLE_CHANGE_LIST',
      'CHANGE_LOG',
      'FILTER_DATA',
      'RANGE_FILTER_DATA',
      'GLOBAL_CHANGE_LIST',
      'SELECTED_ROWS',
      'TOTAL_CHECKBOX',
      'EXCEPTION_ROWS',
    ]),
    fieldsListFull() {
      const length = Math.ceil(this.FIELDS_LIST_FULL.length / 5);
      return this.chunkArray(this.FIELDS_LIST_FULL, length)
    },
    getCellDetailList() {
      let buf = []
      for (let key in this.cellDetailList) {
        buf[key] = this.cellDetailList[key]
        buf[key].value = buf[key].value.replace(/\n/g, '<br />')
      }

      return buf
    },
    getSelectedFile() {
      let selected = []
      for (let key in this.selectedField) {
        if (this.selectedField[key]) {
          selected.push(key)
        }
      }

      return selected
    },
    haveSelectedRow: function () {
      for (let key in this.selectedRow) {
        if (this.selectedRow[key]) {
          return true
        }
      }

      return false
    },
    haveFilter: function () {

      return Object.keys(this.FILTER_DATA).length != 0
          ||
          (
              Object.keys(this.RANGE_FILTER_DATA).length != 0 &&
              (
               Object.keys(this.RANGE_FILTER_DATA.fromSign).length != 0
                || Object.keys(this.RANGE_FILTER_DATA.fromVal).length != 0
                || Object.keys(this.RANGE_FILTER_DATA.toSign).length != 0
                || Object.keys(this.RANGE_FILTER_DATA.toVal).length != 0
              )
          )
    },
    getFieldsList: function () {
      var fields = []
      this.FIELDS_LIST.forEach((val) => {
        let sortable = val.sortable === undefined ? true : val.sortable
        fields.push({
          key: val.key,
          label: productLang[val.key],
          sortable: sortable,
          detailsShowing: true
        })
      })
      return fields
    },
    getFieldsOptions: function () {
      var fields = []
      this.FIELDS_LIST.forEach((val) => {
        fields.push({
          value: val.key,
          text: val.label
        })
      })
      return fields
    },
    getSelectedRow: function ()
    {
      let ids = []
      for (let key in this.selectedRow) {
        if (this.selectedRow[key]) {
          ids.push(key)
        }
      }

      return ids
    },
    getNoSelectedRow: function ()
    {
      let ids = []
      for (let key in this.selectedRow) {
        if (!this.selectedRow[key]) {
          ids.push(key)
        }
      }

      return ids
    }
  },
  watch: {},
  mounted: function () {
    if (this.$store.getters.getAllowSection.indexOf('product') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }

    this.widthTab()
    this.initPageSize()
    this.GET_ALL({th: this})
    this.windowResize()
  },
  created() {
    window.addEventListener("resize", this.widthTab)
    window.addEventListener("resize", this.windowResize)
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize)
  },
}
</script>

<style scoped>
.tab-width {
  width: 10000px;
}

.tab-scroll {
  overflow-x: scroll;
}

.t-cell {
  overflow: hidden;
  display: block;
  height: 23px;
  font-size: 0.9rem;
  padding: 0 0.2rem;
}

.resizable-component {
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: #e9ecef;
  padding: 0.5rem;
  text-align: left;
  font-size: 0.9rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin: 0;
}

.cell-detail.resizable-content {
  background-color: #e9ecef;
}

.cell-cursor {
  cursor: cell;
  padding: 1px;
}

.cell-cursor:hover {
  border: solid 1px grey;
  padding: 0;
}

.cell-cursor.selectedCall {
  border: solid 2px #007bff;
  padding: 0;
}

.name-coll-selected {
  font-size: 0.8rem;
  display: block;
}

.common-head-cell {
  height: 4rem;
  display: block;
  text-align: center;
  padding: 0 0.2rem;
}

.index-call {
  vertical-align: middle;
}

.t-head-cell.number-head {
  display: block;
}

.text-align-left {
  text-align: left;
}

.text-align-right {
  text-align: right;
}

.resizable-content {
  height: 100%;
  width: 100%;
  background-color: aqua;
}

.b-table-sticky-header, .table-responsive, [class*="table-responsive-"] {
  margin-bottom: 0;
}

.apply-cancel-import {
  width: 150px;
}

.pagination-box {
  overflow: auto;
}

.table {
  margin-bottom: 0;
}

.log-content {
  text-align: left;
  font-size: 13px;
}

.checkbox-header {
  width: 30px;
}

.table-header-id {
  width: 115px;
}

.table-header {
  min-width: 145px;
}

.filter-fields-box {
  height: 62px;
}

.cell-name-box {
  height: 45px;
  padding-top: 2px;
}

.edit-form-textarea {
  height: 35px;
}

.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
</style>


<style>
.table th, .table td {
  padding: 0;
  vertical-align: middle;
}

.goods-import html {
  overflow-x: hidden;
}

.edit-action .form-group {
  margin-bottom: 0.5rem;
}

.translation {
  background-color: #FFA500;
}
.margin-1 {
  margin: 1px;
}
.edit-but {
}
.goods-handler .goods-table tbody tr.isSelectedRow {
  background: #00a1ff;
}
.goods-handler .goods-table tbody tr:hover {
  background: #ccc;
}
.checkbox-field-box {
  width: 300px;
  text-align: left;
}
.fields-popup {
  position: absolute;
  z-index: 100;
  width: 1695px;
}
.fields-container {
  margin-left: 25px;
  margin-right: 25px;
}
.fields-container-row {
  width: 1700px;
}
.apply-but {
  padding-right: 115px;
  text-align: right;
}
.select-but {
  text-align: left;
}
.table-content thead {
  position: sticky;
  top: -1px;
  z-index: 9;
}
</style>